import React, { useCallback, useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import cx from 'classnames';

import T from 'i18n-react';

/* Localisation strings */
import Texts from '../../../texts.json';

import styles from './Header.scss';

T.setTexts(Texts);

const HeaderLinksMobile = ({
  children,
  location: { pathname },
  menuOpen,
  setMenuOpen,
}) => {
  let shiftEffect;
  const sidebar = useRef(null);

  const listenForCloseEvent = useCallback(({ target }) => {
    if (!sidebar?.current?.contains(target)) {
      setMenuOpen(false);
      shiftEffect('remove');
    }
  }, [sidebar, setMenuOpen, shiftEffect]);

  shiftEffect = useCallback((vector) => {
    const { body, documentElement } = document;

    body[`${vector}EventListener`]('click', listenForCloseEvent);
    documentElement.classList[vector]('mw-shift-left');
  }, [listenForCloseEvent]);

  useEffect(() => () => {
    setMenuOpen(false);
    shiftEffect('remove');
  }, [setMenuOpen, shiftEffect]);

  useEffect(() => {
    const { current: el } = sidebar;

    if (menuOpen && el) {
      window.scrollTo(0, 0);
      el.scrollTop = 0;
    }

    shiftEffect(menuOpen ? 'add' : 'remove');
  }, [sidebar, menuOpen, shiftEffect]);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname, setMenuOpen]);

  return (
    <nav
      ref={sidebar}
      className={cx(styles.nav, styles.links, styles.navMobile)}
    >
      {children}
    </nav>
  );
};

HeaderLinksMobile.propTypes = {
  children: PropTypes.node.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  menuOpen: PropTypes.bool.isRequired,
  setMenuOpen: PropTypes.func.isRequired,
};

export default withRouter(HeaderLinksMobile);
